import { Dialog } from 'Components/Core';
import { hasNonEmptyValue } from 'Lib/Any';
import webApi from 'Lib/WebApi';
import { useState } from 'react';
import { IWorksheetWorksheetImagePreviewProps } from './types';

/**
 * Renders a thumbnail preview for the provided imageId.
 */
const WorksheetImagePreview: React.FC<IWorksheetWorksheetImagePreviewProps> = ({ imageId, modifiedDate, caption }) => {
  const [showFullImageDialog, setShowFullImageDialog] = useState(false);

  const thumbnailUrl = webApi.worksheets.imageAttachment.buildUri({
    imageId: imageId,
    // Note: we include modifiedDate as a parameter so the url will change when the image is modified and trigger a refresh (even though this isn't recognised by the Web API)
    modifiedDate,
    thumbnail: true,
  });
  const fullImageUri = webApi.worksheets.imageAttachment.buildUri({
    imageId: imageId,
    modifiedDate,
    thumbnail: false,
  });
  const previewCaption = hasNonEmptyValue(caption) ? `${caption} [ Preview ]` : '[ Preview ]';

  // When the thumbnail is clicked, we want to open the full image in a modal dialog
  // if Web App is embedded in another product (i.e. QESTLab or QESTField)
  if (window.qest.isFrame)
    return (
      <>
        <img
          src={thumbnailUrl}
          onClick={(_) => setShowFullImageDialog(true)}
          alt={previewCaption}
          className="WorksheetImagePreview"
        />
        <Dialog title={caption} visible={showFullImageDialog} onClose={() => setShowFullImageDialog(false)}>
          <img src={fullImageUri} alt={caption} />
        </Dialog>
      </>
    );

  // Otherwise open it in a new tab
  return (
    <img
      src={thumbnailUrl}
      onClick={(_) => window.open(fullImageUri, '_blank', 'noopener,noreferrer')}
      alt={previewCaption}
      className="WorksheetImagePreview"
    />
  );
};

export default WorksheetImagePreview;
export { WorksheetImagePreview };
